import { TdsButton, TdsModal } from '@scania/tegel-react'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import type { BeforeDeleteModalProps } from './before-delete-modal.types'

export function BeforeDeleteModal({
  open,
  onClose,
  onSubmit,
  objectName
}: BeforeDeleteModalProps) {
  const { t } = useTranslation('common')
  const modalRef = useRef<HTMLTdsModalElement>(null)

  useEffect(() => {
    if (open) {
      modalRef.current?.showModal()
    } else {
      modalRef.current?.closeModal()
    }
  }, [open])

  const handleClose = () => {
    onClose()
  }

  const handleSubmit = () => {
    onSubmit()
  }

  return (
    <TdsModal
      ref={modalRef}
      size='md'
      header={
        objectName
          ? ` ${t('are-you-sure-you-want-delete', { object: objectName })}`
          : t('are-you-sure')
      }
      onTdsClose={handleClose}
    >
      <span slot='actions' className='tds-u-flex tds-u-gap2'>
        <TdsButton
          variant='primary'
          onClick={handleSubmit}
          size='md'
          text={t('yes')}
        />
        <TdsButton
          variant='secondary'
          onClick={handleClose}
          size='md'
          text={t('no')}
        />
      </span>
    </TdsModal>
  )
}
